import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const PickupPreferencesSection = ({ formData, errors, onChange }) => {
  const pickupOptions = [
    { value: '', label: '배달 방법 선택', disabled: true },
    { value: 'door', label: '문 앞에 두기', description: '벨을 누르지 않고 문 앞에 놓아주세요' },
    { value: 'ring', label: '벨 누르기', description: '도착 시 벨을 눌러주세요' },
    { value: 'custom', label: '직접 입력', description: '특별한 요청사항을 입력하세요' }
  ];

  const handlePickupChange = (value) => {
    onChange({ target: { name: 'pickupType', value } });
  };

  return (
    <div className="rounded-lg bg-card p-6 shadow-lg transition-all duration-300 hover:shadow-xl">
      <h2 className="mb-6 text-xl font-bold text-foreground">배달 선호사항</h2>
      <div className="space-y-4">
        <Select
          label="배달 방법"
          options={pickupOptions}
          value={formData?.pickupType}
          placeholder="옵션을 선택해주세요"
          onChange={handlePickupChange}
          error={errors?.pickupType}
          required
        />
        {formData?.pickupType === 'custom' && (
          <Input
            label="상세 요청사항"
            type="text"
            name="customInstructions"
            placeholder="예: 경비실에 맡겨주세요"
            value={formData?.customInstructions}
            onChange={onChange}
            error={errors?.customInstructions}
          />
        )}
      </div>
    </div>
  );
};

export default PickupPreferencesSection;